module.exports = __webpack_public_path__ + "static/img/post.ab73666.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post.jpg
// module id = 2d+x
// module chunks = 192